import { getFolder } from 'modules/documents/api/getFolder';
import { useCallback, useEffect, useState } from 'react';
import { Folder } from 'types';

type UseGetFolderProps = {
  folderId?: string;
};

export const useGetFolder = ({ folderId }: UseGetFolderProps) => {
  const [folder, setFolder] = useState<Folder | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchFolder = useCallback(
    async (controller: AbortController) => {
      if (!folderId) {
        setFolder(null);
        return;
      }
      try {
        setIsLoading(true);

        const responseFolder = (await getFolder({
          folderId,
          signal: controller.signal,
        })) as Folder;

        if (!controller.signal.aborted) {
          setFolder(responseFolder);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [folderId]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchFolder(controller);

    return () => controller.abort();
  }, [fetchFolder]);

  return {
    data: { folder },
    isLoading,
    isError,
  };
};
